export const ItemTypes = {
	PLAYER: 'player'
}
